import { filter, map } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getStringOrNullProp, getStringProp } from '@mews/fp';
import { Option } from '@mews-commander/legacy-data-structures';
import { localizeText } from '@mews-commander/utils';
import { getCountrySubdivisions as getCountrySubdivisionsSelector } from '@mews-commander/core/legacy-globalization';

export const getCountrySubdivisionByCode = createSelector(
    getCountrySubdivisionsSelector,
    getStringOrNullProp('countrySubdivisionCode'),
    // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
    (subdivisions, countrySubdivisionCode) => subdivisions[countrySubdivisionCode] || {}
);

export const getCountrySubdivisionName = createSelector(
    getCountrySubdivisionByCode,
    (subdivision) => subdivision.code && localizeText(getCountrySubdivisionTextKey(subdivision.code))
);

const getCountrySubdivisionsByCountryCode = createSelector(
    getCountrySubdivisionsSelector,
    getStringProp('countryCode'),
    (subdivisions, countryCode) => filter({ countryCode })(subdivisions)
);

const getCountrySubdivisionTextKey = (code: string) => `CountrySubdivision${code.replace('-', '')}` as Mews.TextKey;

export const getCountrySubdivisionOptions = createSelector(getCountrySubdivisionsByCountryCode, (subdivisions) =>
    map(({ code }) => Option({ value: code, label: localizeText(getCountrySubdivisionTextKey(code)) }))(subdivisions)
);
